import clsx from 'clsx';
import Boto from '../Boto/Boto';
import styles from './modulmiradaglobal.module.scss';
import Icona from '../../../components/3catinfo/ui/Icona';

const ModulMiradaGlobal = (props) => {
    const { titol, text, textBoto, linkBoto, estil } = props;

    const stylesModul = clsx(styles.modulMiradaGlobal, estil && styles[estil]);

    return (
        <div className={stylesModul} data-testid='newsletter'>
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <Icona inline={true} className={styles.icona} icona='sobre' ariaHidden={true} />
                    <h2 className={styles.titol} data-testid='newsletter-titol'>
                        {titol}
                    </h2>
                    <p className={styles.text} data-testid='newsletter-text'>
                        {text}
                    </p>
                    <Boto className={styles.boto} text={textBoto} link={linkBoto} tema='negre' dataTestId='newsletter-boto' />
                </div>
            </div>
        </div>
    );
};

export default ModulMiradaGlobal;
